import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.logout(result => {
      resolve(result.data)
    }, param)
  })
}
